<template>
    <span></span>
</template>

<script setup lang="ts">
    import {onUnmounted, ref} from 'vue';
    import {storeToRefs} from 'pinia';
    import {onMounted, useAuth, useCookie, useLogger} from '#imports';
    import type {Emitter} from '@malt/vue-event-bus/create-event-bus';
    import {pushVJoySnackbar, type TJoySnackbarEvents, type TJoySnackbarLevels} from '@maltjoy/core-vue';

    const auth = useAuth();
    const logger = useLogger();
    const {loggedIn, user} = storeToRefs(auth);
    const eventsBus = ref<Emitter<TJoySnackbarEvents>[]>([]);

    onMounted(() => {
        checkIfPlatformNotificationsShouldBeDisplayed();
    });

    type PlatformNotificationResource = {
        id: string;
        content: string;
        criticality: string;
        knowledgeable: boolean;
    };

    function checkIfPlatformNotificationsShouldBeDisplayed() {
        if (!loggedIn.value) {
            return;
        }

        if (user.value?.extraInformation?.platformNotifications) {
            const platformNotificationsAsString = user.value?.extraInformation?.platformNotifications;
            try {
                JSON.parse(platformNotificationsAsString).forEach((platformNotification: PlatformNotificationResource) => {
                    // display if applicable and not already acknowledged
                    const acknowledgedCookie = useCookie<boolean>(`platform-acknowledged-${platformNotification.id}`);
                    if (acknowledgedCookie.value) {
                        return;
                    }
                    const {snackbarEventBus} = pushVJoySnackbar({
                        props: {
                            message: platformNotification.content,
                            level: platformNotification.criticality.toLowerCase() as TJoySnackbarLevels,
                            duration: 'forever',
                        },
                    });
                    if (platformNotification.knowledgeable) {
                        snackbarEventBus.on('snackbar:hide', () => {
                            acknowledgedCookie.value = true;
                        });
                        eventsBus.value.push(snackbarEventBus);
                    }
                });
            } catch (e) {
                logger.error(e);
            }
        }
    }

    onUnmounted(() => {
        eventsBus.value.forEach((bus: Emitter<TJoySnackbarEvents>) => {
            bus.off('snackbar:hide');
        });
    });
</script>
